import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDate } from "@/lib/format";

const rs = (v) =>
  "Rs. " +
  Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function downloadStatement(customer, txns) {
  const doc = new jsPDF();
  const rows = [...txns].sort(
    (a, b) => a.created_at.localeCompare(b.created_at) || a.id.localeCompare(b.id),
  );
  const credits = rows.filter((t) => t.type === "credit").reduce((s, t) => s + t.amount, 0);
  const debits = rows.filter((t) => t.type === "debit").reduce((s, t) => s + t.amount, 0);

  doc.setFont("helvetica", "bold").setFontSize(20).text("ThankF", 14, 20);
  doc.setFont("helvetica", "normal").setFontSize(11).text("Account Statement (Full history)", 14, 28);
  doc.setFontSize(10);
  doc.text(`Name: ${customer?.name || ""}`, 14, 40);
  doc.text(`Mobile: ${customer?.mobile || ""}`, 14, 46);
  doc.text(`Generated: ${formatDate(new Date())}`, 14, 52);
  doc.text(`Current balance: ${rs(customer?.balance)}`, 196, 40, { align: "right" });
  doc.text(`Total credits: ${rs(credits)}`, 196, 46, { align: "right" });
  doc.text(`Total debits: ${rs(debits)}`, 196, 52, { align: "right" });

  autoTable(doc, {
    startY: 60,
    head: [["Date", "Type", "Note", "Amount", "Balance"]],
    body: rows.length
      ? rows.map((t) => [
          formatDate(t.created_at),
          t.type === "credit" ? "Credit" : "Debit",
          t.note || "-",
          (t.type === "credit" ? "+ " : "- ") + rs(t.amount),
          rs(t.balance_after),
        ])
      : [[{ content: "No transactions yet.", colSpan: 5, styles: { halign: "center" } }]],
    headStyles: { fillColor: [15, 23, 42] },
    columnStyles: { 3: { halign: "right" }, 4: { halign: "right" } },
    styles: { fontSize: 9 },
  });

  const safeName = (customer?.name || "customer").replace(/[^a-z0-9]+/gi, "_");
  doc.save(`ThankF_Statement_${safeName}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
